import AppointmentTypeForm from '@/components/actions/AppointmentTypeForm.vue'
// import NewAppointmentTypeWizard from '@/components/actions/wizards/NewAppointmentTypeWizard.vue'
import AppointmentTypeWizard from '@/components/actions/wizards/AppointmentTypeWizard/index.vue'
import InviteMemberWizard from '@/components/actions/wizards/InviteMemberWizard/index.vue'
import NewLocationWizard from '@/components/actions/wizards/NewLocationWizard/index.vue'
// import NewSpaceWizard from '@/components/actions/wizards/SpaceWizard/Index.vue'
import NewSpaceWizard from '@/components/actions/wizards/SpaceWizard/Decision.vue'

import LocationForm from '@/components/actions/LocationForm.vue'
import OperatingHours from '@/components/actions/OperatingHoursForm.vue'

/*
See src/mixins/launcher.js for shortcut commands to launch registered components
*/

export default {
  'quick-appointment-type-form': {
    component: AppointmentTypeWizard,
    index: 'appointment type new create product'
  },
  'appointment-type-form': {
    component: AppointmentTypeForm,
    index: 'appointment type product'
  },
  'new-space-wizard': {
    component: NewSpaceWizard,
    index: 'New space business practice'
  },
  'new-location-wizard': {
    component: NewLocationWizard,
    index: 'new location create location add location'
  },
  'location-form': {
    component: LocationForm,
    index: 'space location address'
  },
  'operation-hours-form': {
    component: OperatingHours,
    index: 'operating hours times'
  },
  'invite-member-wizard': {
    component: InviteMemberWizard,
    index: 'new member invite member add member space service practitioner'
  }
}
